<template lang="pug">
div
  iframe(
    v-if="embedUrl"
    :src="embedUrl"
    frameborder="0"
    height="1200"
    style="width: 100%"
    allowtransparency
  )
</template>
<script setup lang="ts">
import SnowflakeService from '@/services/SnowflakeService';
import { watch } from 'vue';
import { ref } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const loading = ref(true);
const embedUrl = ref('');

const reload = async () => {
  loading.value = true;

  const request = {
    resource: {
      dashboard: 80
    },
    params: {
      couponid: [props.id]
    }
  };

  try {
    const response = await SnowflakeService.generateMetabaseEmbedToken(request);

    embedUrl.value = `https://metabase.uptack.io/embed/dashboard/${response.token}#bordered=false&titled=false`;
  } finally {
    loading.value = false;
  }
};

watch(() => props.id, () => {
  reload()
}, {
  immediate: true
});
</script>
